import React, { Dispatch } from "react";
import { ActionType } from "./types";
import { GetProductDto } from "../../services/Product/dto/get.dto";
import { UpdateStatusParams } from "./usecase.d";

export type ProductStateType = {
  data: Array<GetProductDto>;
};

export type ProductActionType = {
  type: symbol;
  items?: GetProductDto[];
  updatedItem?: GetProductDto;
  updatedItems?: GetProductDto[];
  updatedStatusItem?: UpdateStatusParams;
};

type ProductReducerType = React.Reducer<ProductStateType, ProductActionType>;

export type ProductDispatch = Dispatch<ProductActionType>;

const initialGetState: ProductStateType = {
  data: new Array<GetProductDto>(),
};

interface TransformUpdateStatusParams {
  originalData: Array<GetProductDto>;
  updatedData: UpdateStatusParams;
}

function transformUpdateStatusData({
  originalData,
  updatedData,
}: TransformUpdateStatusParams) {
  return originalData.map((item) => {
    const newItem = { ...item };
    if (item.productKey === updatedData.productKey) {
      newItem.isActive = updatedData.isActive;
      return newItem;
    }
    return newItem;
  });
}

interface TransformUpdateDataParams {
  originalData: Array<GetProductDto>;
  updatedData: GetProductDto;
}

function transformUpdateData({
  originalData,
  updatedData,
}: TransformUpdateDataParams) {
  return originalData.map((item) => {
    if (item.productKey === updatedData.productKey) {
      return updatedData;
    }
    return item;
  });
}

interface TransformUpdateDataListParams {
  originalData: Array<GetProductDto>;
  updatedDataList: GetProductDto[];
}

function transformUpdateDataList({
  originalData,
  updatedDataList,
}: TransformUpdateDataListParams) {
  return originalData.map((item) => {
    for (let index = 0; index < updatedDataList.length; index++) {
      const targetData = updatedDataList[index];
      if (item.productKey === targetData.productKey) {
        return targetData;
      }
    }
    return item;
  });
}

export const Reducer: ProductReducerType = (
  state = initialGetState,
  action,
) => {
  switch (action.type) {
    case ActionType.GetList:
      return {
        data: action.items || [],
      };
    case ActionType.Update:
      if (!action.updatedItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        data: transformUpdateData({
          originalData: state.data,
          updatedData: action.updatedItem,
        }),
      };
    case ActionType.UpdateList:
      if (!action.updatedItems) {
        throw new Error("Updated item list does not exists");
      }
      return {
        data: transformUpdateDataList({
          originalData: state.data,
          updatedDataList: action.updatedItems,
        }),
      };
    case ActionType.UpdateStatus:
      if (!action.updatedStatusItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        data: transformUpdateStatusData({
          originalData: state.data,
          updatedData: action.updatedStatusItem,
        }),
      };
    default:
      return state;
  }
};
